import { Transaction } from "@finway-group/shared/lib/models"

export const isTransactionArchived = (transaction: Pick<Transaction, "isArchived">) => transaction.isArchived

export const isTransactionManuallyUnarchived = (transaction: Pick<Transaction, "isAutoArchiveOff">) => transaction.isAutoArchiveOff

export const getVendorIdsFromTransactions = (transactions: Array<Transaction>) => transactions.map((transaction) => transaction.transactionData.vendor).filter((vendor) => vendor)
